"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _default() {
  return function (_ref) {
    var addUtilities = _ref.addUtilities,
        e = _ref.e,
        theme = _ref.theme,
        variants = _ref.variants;

    var utilities = _lodash.default.fromPairs(_lodash.default.map(theme('fontSize'), function (value, modifier) {
      var _ref2 = Array.isArray(value) ? value : [value],
          _ref3 = _slicedToArray(_ref2, 2),
          fontSize = _ref3[0],
          lineHeight = _ref3[1];

      return [".".concat(e("text-".concat(modifier))), _objectSpread({
        'font-size': fontSize
      }, lineHeight === undefined ? {} : {
        'line-height': lineHeight
      })];
    }));

    addUtilities(utilities, variants('fontSize'));
  };
}